import * as React from 'react'
import { Typography, Popper, Fade, Paper, styled, Backdrop, Box } from '@mui/material'
import { ReactComponent as CloseIcon } from './Assets/Close.svg'
import { ReactComponent as Explanation } from './Assets/Explanation.svg'
import { T } from 'GlobalStores/Cores/Translator/useTranslate'

export default function PopperPopup({ paragraph = `` }) {
    const [arrowRef, setArrowRef] = React.useState(null)
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [open, setOpen] = React.useState(false)

    const handleClick = event => {
        setOpen(!open)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
        setOpen(false)
    }

    React.useEffect(() => {
        const handleScroll = () => {
            if (!anchorEl) return
            handleClose()
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [anchorEl])

    return (
        <div style={{ position: 'relative' }}>
            <Explanation onClick={handleClick} width={'18px'} height={'18px'} style={{ cursor: 'pointer' }} />
            <Popper
                sx={{
                    '@media (min-width: 1179px)': {
                        bottom: '20px !important'
                    },
                    bottom: '20px !important',
                    borderRadius: '8px !important',
                    border: 'none !important',
                    zIndex: 9999,
                    padding: '0 30px 0 30px'
                }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                placement={'top'}
                transition
                keepMounted
                modifiers={[
                    {
                        name: 'flip',
                        enabled: false,
                        options: {
                            altBoundary: true,
                            rootBoundary: 'viewport'
                        }
                    },
                    {
                        name: 'preventOverflow',
                        enabled: true,
                        options: {
                            altAxis: false,
                            altBoundary: true,
                            tether: true,
                            rootBoundary: 'viewport'
                        }
                    },
                    {
                        name: 'arrow',
                        enabled: true,
                        options: {
                            element: arrowRef
                        }
                    }
                ]}>
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper
                            sx={{
                                borderRadius: '8px !important',
                                width: 'auto',
                                padding: '20px 30px 30px 30px',
                                backgroundColor: '#fff',
                                boxShadow: '0px 4px 18px rgba(0, 0, 0, 0.05)',
                                boxSizing: 'border-box',
                                '@media screen and (min-width: 550px)': {
                                    width: '506px'
                                }
                            }}>

                            <Arrow ref={setArrowRef}>
                                <Triangle />
                            </Arrow>

                            <Box
                                sx={{
                                    position: 'absolute',
                                    cursor: 'pointer',
                                    right: '40px',
                                }}>
                                <CloseIcon onClick={() => handleClose()} />
                            </Box>

                            <Content>
                                <Box>
                                    <Typography
                                        variant="h3"
                                        color="#0B3B61"
                                        sx={{
                                            textAlign: 'center',
                                            width: '100%',
                                            fontWeight: 400,
                                            fontSize: '16px',
                                            lineHeight: '24px'
                                        }}>
                                        <T>{paragraph}</T>
                                    </Typography>
                                </Box>
                            </Content>
                        </Paper>
                    </Fade>
                )}
            </Popper>

            <Backdrop sx={{ color: '#fff', zIndex: 1, cursor: 'auto !important', background: 'rgba(56, 66, 80, 0.2)' }} open={open} onClick={() => handleClose()} />
        </div>
    )
}

const Arrow = styled('span')`
    bottom: 5px;
    position: absolute;
    width: 20px;
    height: 10px;
`

const Triangle = styled('div')`
    content: '';
    box-sizing: border-box;
    position: absolute;
    width: 19px;
    height: 19px;
    background: #fff;
    transform: rotate(45deg);
`

const Content = styled('div')`
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    font-family: Poppins, Inter, NotoSansThai !important;
    font-style: normal;
    span {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        color: #003764;
    }

    .content-title {
        display: flex;
        flex-direction: row;
        width: '100%';
    }

    *.MuiTypography-root{
        font-family: Poppins, Inter, NotoSansThai !important;
    }
`